import styled, { css } from 'styled-components';
import { Button } from 'rebass';
import { theme } from '../../styles/theme';
import chevronBlack from '../../assets/icons/Chevron_THINNER_V1.svg';
import chevronWhite from '../../assets/icons/Chevron_THINNER_V1_WHITE.svg';
import isDarkColour from '../../utils/isDarkColour';

const CarouselChevron = styled(Button)`
  &&& {
    @media (max-width: ${theme.breakpoint.md}) {
      display: none;
    }
    position: absolute;
    top: 50%;
    background-size: contain;
    background-repeat: no-repeat;
    background-color: transparent;
    padding: 0;
    width: 32px;
    height: 32px;

    ${(props) =>
      props.left &&
      css`
        background-image: url(${chevronBlack});
        transform: translateY(-50%) rotate(180deg);
        left: 0;

        ${(props) =>
          isDarkColour(props.colourScheme) &&
          css`
            background-image: url(${chevronWhite});
          `}
      `}

    ${(props) =>
      props.right &&
      css`
        background-image: url(${chevronBlack});
        transform: translateY(-50%);

        transform-origin: center;
        right: 0;

        ${(props) =>
          isDarkColour(props.colourScheme) &&
          css`
            background-image: url(${chevronWhite});
          `}
      `}
  }
`;

export default CarouselChevron;
